module.exports = __webpack_public_path__ + "img/art_1_1.930f23af.jpeg";